import { defineStore } from 'pinia';
import i18n from '@/common/i18n';
import ReserveRepository from '@/repositories/reserveRepository';
import { ServiceDetailResponse, RegulationDetailResponse, RsvisulstResponce, RsvlnglstResponce, RsvcalromlstResponce, RsvsrgrgnlstResponce, RsvsrgaralstResponce } from '@/models/reserve/reservePlanningModel';
import { RsvdtlRequest, ReserveDetailRequest, RsvdtlResponce } from '@/models/reserve/reserveModel';
//import { RsvlstResponce } from '@/models/reserve/reserveModel';
import cognitoRepository from '@/repositories/common/cognitoRepository';
import apiResponseErrorService from '@/commonProject/service/apiResponseErrorService';

// Utis
import utils from '@/commonProject/helpers/utils';

export const useReserveStore = defineStore({
    id: 'reserve',
    state: () => ({
        rsvdtlRequest: new RsvdtlRequest(),
        reserveDetailRequest: new ReserveDetailRequest(),
        serviceDetail: new ServiceDetailResponse(),
        regulationDetail: new RegulationDetailResponse(),
        //reserveList: new RsvlstResponce(),
        reserveList: [],
        reserveDetail: new RsvdtlResponce(),
        pageInfo: 0,
        serviceList: [],
        issueList: [],
        languageList: [],
        cngMethodTypes: [],
        cngReserveTypes: [],
        counselorList: [],
        counselorList2: [],
        regionList: [],
        areaList: [],
        roomList: [],
        calendarTimeList: [],
        arrangeTimeList: [],
        sessionNum: 0,
        reservationPk: '',
        formatDate: '',
        formatTime: '',
        restoreFlag: false,
        reserveStep: {
            consultation: {
                reserveplanningconsultation: false, // 予約(相談内容から利用方法等選択)画面に戻る
                reserveplanningservice: false, // 予約(相談内容からサービス選択)画面に戻る
                reserveplanningagree: false, // 予約(規定同意)画面に戻る
            },
            program: {
                reserveplanningprogram: false, // 予約(プログラムからサービス選択)画面
                reserveplanningagree: false, // 予約(規定同意)画面に戻る
                reserveplanningselection: false, // 予約(プログラムから利用方法など選択)画面
            },
            personal: {
                reserveplanningpersonal: false, // 予約(割り当てからサービス選択)画面
                reserveplanningagree: false, // 予約(規定同意)画面に戻る
                reserveplanningselection: false, // 予約(プログラムから利用方法など選択)画面
            },
        }, // 予約画面のいずれのステップ座標から遷移したのかを保管する。
    }),
    getters: {
        getIssueName: (state) => (pk) => {
            const issueName = state.issueList.find((select) => select.pk === pk)?.name || '';
            return issueName;
        },
        getLanguageName: (state) => (pk) => {
            const languageName = state.languageList.find((select) => select.pk === pk)?.name || '';
            return languageName;
        },
        getServiceName: (state) => (pk) => {
            const serviceName = state.serviceList.find((service) => service.ServicePk === pk)?.ServiceNm || '';
            return serviceName;
        },
        getCounselorName: (state) => (pk) => {
            const counselorName = state.counselorList2.find((counselor) => counselor.CounselorPk === pk)?.CounselorNm || '';
            return counselorName;
        },
        getRegionName: (state) => (pk) => {
            const regionName = state.regionList.find((region) => region.pk === pk)?.name || '';
            return regionName;
        },
        getAreaName: (state) => (pk) => {
            const areaName = state.areaList.find((area) => area.pk === pk)?.name || '';
            return areaName;
        },
        getRoomName: (state) => (pk) => {
            const areaName = state.roomList.find((room) => room.pk === pk)?.name || '';
            return areaName;
        },
    },
    actions: {
        clearAll() {
            this.clearRequestData();
            this.clearReserveDetailRequest();
            this.clearServiceDetail();
            this.clearRegulationDetail();
            this.clearReserveList();
            this.clearReserveDetail();
            this.pageInfo = 0;
            this.serviceList = [];
            this.issueList = [];
            this.languageList = [];
            this.cngMethodTypes = [];
            this.cngReserveTypes = [];
            this.counselorList = [];
            this.counselorList2 = [];
            this.regionList = [];
            this.areaList = [];
            this.roomList = [];
            this.calendarTimeList = [];
            this.arrangeTimeList = [];
            this.sessionNum = 0;
            this.reservationPk = '';
            this.formatDate = '';
            this.formatTime = '';
            this.keepIssuePk1 = '';
            this.keepSelectDate = new Date();
            this.reserveStep = {
                consultation: {
                    reserveplanningconsultation: false, // 予約(相談内容から利用方法等選択)画面に戻る
                    reserveplanningservice: false, // 予約(相談内容からサービス選択)画面に戻る
                    reserveplanningagree: false, // 予約(規定同意)画面に戻る
                },
                program: {
                    reserveplanningprogram: false, // 予約(プログラムからサービス選択)画面
                    reserveplanningagree: false, // 予約(規定同意)画面に戻る
                    reserveplanningselection: false, // 予約(プログラムから利用方法など選択)画面
                },
                personal: {
                    reserveplanningpersonal: false, // 予約(割り当てからサービス選択)画面
                    reserveplanningagree: false, // 予約(規定同意)画面に戻る
                    reserveplanningselection: false, // 予約(プログラムから利用方法など選択)画面
                },
            }; // 予約画面のいずれのステップ座標から遷移したのかを保管する。
        },

        clearReserveDetailRequest() {
            this.reserveDetailRequest = new ReserveDetailRequest();
        },
        clearServiceDetail() {
            this.serviceDetail = new ServiceDetailResponse();
        },
        clearRegulationDetail() {
            this.regulationDetail = new RegulationDetailResponse();
        },
        clearReserveList() {
            //this.reserveList = new RsvlstResponce();
            this.reserveList = [];
        },
        clearReserveDetail() {
            this.reserveDetail = new RsvdtlResponce();
        },
        clearReserveStep() {
            this.reserveStep = {
                consultation: {
                    reserveplanningconsultation: false,
                    reserveplanningservice: false,
                    reserveplanningagree: false,
                },
                program: {
                    reserveplanningprogram: false,
                    reserveplanningagree: false,
                    reserveplanningselection: false,
                },
                personal: {
                    reserveplanningpersonal: false,
                    reserveplanningagree: false,
                    reserveplanningselection: false,
                },
            };
        },
        /**
         * リクエストデータを設定する
         * @param {object} data
         */
        setRsvdtlRequestData(data) {
            this.rsvdtlRequest = data;
        },
        /**
         * リクエスト情報をクリアする
         */
        clearRequestData() {
            this.rsvdtlRequest = new RsvdtlRequest();
        },
        formattedTime(start, end) {
            // APIから取得したデータを引数で引き継ぎ、値がnullの場合は空を返却する。
            if (utils.isNull(start) && utils.isNull(end)) {
                return '';
            }

            const startDate = start.split(' ')[0];
            const endDate = start.split(' ')[1];
            const endHour = end.split(' ')[1];

            return `${startDate} ${endDate} ~ ${endHour}`;
        },
        splitDateTime(dateTime) {
            // APIから取得したデータを引数で引き継ぎ、値がnullの場合は空として解釈し、処理を終了する。
            if (utils.isNull(dateTime)) {
                this.formatDate = '';
                this.formatTime = '';
                return;
            }

            const [datePart, timePart] = dateTime.split(' ');
            const [year, month, day] = datePart.split('/');
            this.formatDate = `${year}-${month}-${day}`;
            this.formatTime = timePart;
        },
        /**
         * 予約イシュー一覧API
         * @param {*} req
         * @returns response
         */
        async getIssuesAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const reserveRepository = new ReserveRepository();
            try {
                const response = await reserveRepository.getIssueApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.issueList = response.data.List.map((item) => RsvisulstResponce.formApiResponse(item));
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * 予約利用方法一覧API
         * @param {*} req
         * @returns response
         */
        async getManegmentAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const reserveRepository = new ReserveRepository();
            try {
                const response = await reserveRepository.getManegmentApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.cngMethodTypes = response.data.CngMethodTypes;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * 予約利用言語一覧API
         * @param {*} req
         * @returns response
         */
        async getLanguageAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const reserveRepository = new ReserveRepository();
            try {
                const response = await reserveRepository.getLanguageApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.languageList = response.data.List.map((item) => RsvlnglstResponce.formApiResponse(item));
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * サービス一覧取得API
         * @param {object} req
         */
        async getReserveServiceAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const reserveRepository = new ReserveRepository();
            try {
                const response = await reserveRepository.getReserveServiceApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.serviceList = response.data.List;
                this.assignedProgram = false;
                this.used3MonthAgo = false;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * 予約方法一覧取得API
         * @param {*} req
         * @returns response
         */
        async getTabListAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const reserveRepository = new ReserveRepository();
            try {
                const response = await reserveRepository.getTabListApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.cngReserveTypes = response.data.CngReserveTypes;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * 予約カレンダー施設一覧取得API
         * @param {*} req
         * @returns response
         */
        async getCalendarRoomAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const reserveRepository = new ReserveRepository();
            try {
                const response = await reserveRepository.getCalendarRoomApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.roomList = response.data.List.map((item) => RsvcalromlstResponce.formApiResponse(item));
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * 予約カレンダー日付一覧取得API
         * @param {*} req
         * @returns response
         */
        async getCalendarDayAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const reserveRepository = new ReserveRepository();
            try {
                const response = await reserveRepository.getCalendarDayApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.calendarTimeList = response.data.Dates;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * 予約カレンダー時刻一覧取得API
         * @param {*} req
         * @returns response
         */
        async getCalendarTimeAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const reserveRepository = new ReserveRepository();
            try {
                const response = await reserveRepository.getCalendarTimeApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }

                // 初期化。
                this.counselorList = [];
                this.counselorList2 = response.data.List;
                let dataA = {};
                if (!utils.isEmptyArray(this.counselorList2)) {
                    for (const data of this.counselorList2) {
                        //dataA.push(data);
                        const A = data['Time'];
                        const B = {
                            CounselorId: data['CounselorId'],
                            CounselorNm: data['CounselorNm'],
                            CounselorPk: data['CounselorPk'],
                            Time: data['Time'],
                        };
                        if (utils.isNull(dataA[A])) {
                            const C = { [A]: Array(B) };
                            Object.assign(dataA, C);
                        } else {
                            dataA[A].push(B);
                        }
                        let sort = Object.entries(dataA);
                        sort.sort(function (p1, p2) {
                            var p1Key = p1[0],
                                p2Key = p2[0];
                            if (p1Key < p2Key) {
                                return -1;
                            }
                            if (p1Key > p2Key) {
                                return 1;
                            }
                            return 0;
                        });
                        dataA = Object.fromEntries(sort);
                    }
                }
                //this.counselorList = response.data.List;
                this.counselorList = dataA;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * 予約アレンジ地域一覧取得API
         * @param {*} req
         * @returns response
         */
        async getArrangeRegionAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const reserveRepository = new ReserveRepository();
            try {
                const response = await reserveRepository.getArrangeRegionApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.regionList = response.data.List.map((item) => RsvsrgrgnlstResponce.formApiResponse(item));
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * 予約アレンジ地区一覧取得API
         * @param {*} req
         * @returns response
         */
        async getArrangeAreaAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const reserveRepository = new ReserveRepository();
            try {
                const response = await reserveRepository.getArrangeAreaApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.areaList = response.data.List.map((item) => RsvsrgaralstResponce.formApiResponse(item));
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * 予約アレンジ日付一覧取得API
         * @param {*} req
         * @returns response
         */
        async getArrangeDayAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const reserveRepository = new ReserveRepository();
            try {
                const response = await reserveRepository.getArrangeDayApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.arrangeTimeList = response.data.Dates;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * 予約一覧取得API
         * @param {object} req
         */
        async getListAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const reserveRepository = new ReserveRepository();
            try {
                const response = await reserveRepository.getReserveListApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.reserveList = response.data.List;
                this.pageInfo = response.data.PageInfo.RowResult;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * 予約登録API
         * @param {object} req
         */
        async getReserveCreateAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const reserveRepository = new ReserveRepository();
            try {
                const response = await reserveRepository.getReserveCreateApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                return { success: true, linkUrl: response.data.LinkUrl, reservationPk: response.data.ReservationPk };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },

        /**
         * 予約詳細取得API
         * @param {object} req
         */
        async getDetailAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const reserveRepository = new ReserveRepository();
            try {
                const response = await reserveRepository.getReserveDetailApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.reserveDetail = response.data;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * 予約更新API
         * @param {object} req
         */
        async getReserveUpdateAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const reserveRepository = new ReserveRepository();
            try {
                const response = await reserveRepository.getReserveUpdateApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.reserveDetail = response.data;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * 予約取消API
         * @param {object} req
         */
        async getReserveDeleteAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const reserveRepository = new ReserveRepository();
            try {
                const response = await reserveRepository.getReserveDeleteApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.reserveDetail = response.data;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * サービス詳細取得API
         * @param {object} req
         */
        async getServiceDetailAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const reserveRepository = new ReserveRepository();
            try {
                const response = await reserveRepository.getServiceDetailApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.serviceDetail = response.data;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * 規定詳細取得API
         * @param {object} req
         */
        async getRegulationDetailAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const reserveRepository = new ReserveRepository();
            try {
                const response = await reserveRepository.getRegulationDetailApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.regulationDetail = response.data;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * セッショングループ詳細取得API
         */
        async getSessionGroupDetailAction(API_URL, queryParam) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const reserveRepository = new ReserveRepository();
            try {
                const response = await reserveRepository.getSessionGroupDetailApi(API_URL, queryParam, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.sessionNum = response.data.SessionNum;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
    },
    persist: {
        // セッションストレージに保存する
        storage: sessionStorage,
    },
});
